import { Box, Typography, Chip } from '@astro-ui/components'

export type RenderMultipleValueType = {
  value: string[]
  placeholder?: string
  multipleProps?: {
    valueType?: 'chip' | 'total'
    suffixTotal?: string
    hideSelectAll?: boolean
    selectAllText?: string
  }
  onDelete: (_: string) => void
  /**
   * Maps a selection entry to its chip label. Only needed when the entry is an
   * identity (e.g. an id) rather than the display text. Omitted = entry is the label.
   */
  getLabel?: (_: string) => string
}

const RenderMultipleValue = ({
  value,
  multipleProps,
  placeholder,
  onDelete,
  getLabel,
}: RenderMultipleValueType) => {
  if (!value.length)
    return (
      <Typography color={!value.length ? 'grey2' : 'grey9'} variant="body2">
        {placeholder}
      </Typography>
    )

  if (multipleProps?.valueType === 'total') {
    return (
      <Typography color="grey9" variant="body2">
        {`${value.length} ${multipleProps?.suffixTotal || 'Selected'}`}
      </Typography>
    )
  }

  return (
    <Box display="flex" flexWrap="wrap" gap="4px" className="multiple-value-container">
      {value.map((name) => (
        <Chip
          key={name}
          label={getLabel ? getLabel(name) : name}
          p="0 4px"
          size="small"
          onDelete={() => onDelete(name)}
          onMouseDown={(event) => {
            event.stopPropagation()
          }}
        />
      ))}
    </Box>
  )
}

export default RenderMultipleValue
